import { render, staticRenderFns } from "./FoodQrDialog.vue?vue&type=template&id=cccae446"
import script from "./FoodQrDialog.vue?vue&type=script&lang=js"
export * from "./FoodQrDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports